import React from "react";
import PageLayout from "../../components/PageLayout";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";

const QuoteDisabled = () => {
  return (
    <PageLayout pageWidth="wider">
      <ScrollToTop />
      <Card title="We’re not taking on new cases right now" removeTopPadding>
        <p>
          We take on a limited number of cases so we can give every client the attention they deserve. Right now, we’re
          at capacity.
        </p>
        <p>
          We’re sorry we can’t help you today. Please do check back with us — we open up new spaces regularly and would
          love to help with your move.
        </p>
      </Card>
      <Image src={imageOfficeWorking} fullWidth />
    </PageLayout>
  );
};

export default QuoteDisabled;
